export const getMessageSurfaceClassName = (isOwnMessage) => (isOwnMessage ? 'message-surface--mine' : 'message-surface--not-mine');

export const getMessageBubbleSurfaceClassName = (isOwnMessage) =>
  `${getMessageSurfaceClassName(isOwnMessage)} ${
    isOwnMessage ? 'richdown-bubble--channel-message-mine' : 'richdown-bubble--channel-message-not-mine'
  }`;
